type WorkloadPeriod = {
  from: string;
  to: string;
  capacity: number;
  load: number;
};

const workloadPeriod: WorkloadPeriod = {
  from: "",
  to: "",
  capacity: 0,
  load: 0,
};

export type { WorkloadPeriod };

export { workloadPeriod };
